import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {Component, Input, OnDestroy, OnInit, Output, EventEmitter} from "@angular/core";
import { Parser } from "json-logic-parser";
import { ToastrService } from "ngx-toastr";
import { FormulaCost } from "../../../../../../models/formula-cost";
import { FormulaCostItem } from "../../../../../../models/formula-cost-item";
import { CostView } from "../../../../../../models/infix-formula/costView";
import {InfixFormula} from "../../../../../../models/infix-formula/infix-formula";
import {ClassificationControllerService} from "../../../../../../services/classifications-controller/classification-controller.service";
import { CostControllerService } from "../../../../../../services/cost-controller/cost-controller.service";
import { CostService } from "../../../../../../services/cost-controller/cost.service";
import { DeterminantService } from "../../../../../../services/registration-controller/determinant.service";
import {Store} from "../../../../../../services/store.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "cost-items",
  templateUrl: "./cost-items.component.html",
  styles: [],
  providers: [],
})
export class CostItemsComponent extends TranslatedBaseError implements OnInit, OnDestroy {

  @Input() public formulaCost: FormulaCost = new FormulaCost();
  @Input() public costView: CostView;
  @Input() public serviceId: string;
  @Input() public determinantMapById: { [key: string]: string };

  @Output() public changeFormula = new EventEmitter();
  @Output() public changeFormulaDeterminant = new EventEmitter();

  public newRow: FormulaCostItem = new FormulaCostItem();
  public jsonDeterminants: any;
  public selectedIndex: number;
  public infixUsedForDeterminants: boolean = false;

  public infixToJsonLogicParser: Parser;

  public subscriptionFormula: any;
  public subscriptionDeterminant: any;

  public selectedFormulaRow: FormulaCostItem = new FormulaCostItem();
  public showDrawerHeader: boolean = true;
  public showDeterminantBuilder: boolean = false;
  public openFormula: boolean = false;

  constructor(private costService: CostService,
              private costControllerService: CostControllerService,
              private determinantService: DeterminantService,
              private classificationControllerService: ClassificationControllerService,
              public store: Store,
              toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
    this.infixToJsonLogicParser = new Parser();
  }

  public ngOnInit() {
    this.translateService.onLangChange.subscribe(() => {
      this.costView.reloadPrettyPrint(this.formulaCost, this.translateService);
    });
    this.subscriptionFormula = this.costService.changeFormula.subscribe((data) => {
      console.log("CostItemsComponent: changeFormula received", data);
      this.costView = data.costView;
      this.initCostView();
    });
    this.subscriptionDeterminant = this.determinantService.updateCostDeterminant.subscribe((data) => {
      this.selectedIndex = data.selectedIndex;
      this.saveDeterminantModal(data.jsonString);
    });

    if (this.infixUsedForDeterminants) {
      this.classificationControllerService.getClassificationsByService(this.serviceId).subscribe(
          (data) => {
            // @ts-ignore
            data.forEach((classification) => {
              if (!this.costView.properties.find( (prop) => prop.id === classification.id)) {
                this.costView.properties.push({id: classification.id, name: classification.id, label: classification.name });
              }
              classification.fields.forEach((field) => {
                if (!this.costView.properties.find( (prop) => prop.id === field.id)) {
                  this.costView.properties.push({id: field.id, name: field.id, label: field.value });
                }
              });
            });

          },
      );
    }
  }

  public dropped(event: CdkDragDrop<any[]>) {
      if (event.previousContainer === event.container) {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
          // component logic
          this.fixCostItemIndexes();
      }
  }

  public fixCostItemIndexes() {
    this.formulaCost.formulaCostItems.forEach((it, index, itemsArray) => {
      itemsArray[index].sortOrder = index;
    });
  }

  public ngOnDestroy() {
    this.subscriptionFormula.unsubscribe();
    this.subscriptionDeterminant.unsubscribe();
  }

  public isFormulaSpecified() {
    if (!this.costView.formula) { return false; }
    return this.costView.formula !== `(${this.costView.infixSeparator})`;
  }

  public setupInfixFormula() {
    let formulaObj;
    let formulaBroken = false;
    let jsonLogicFormula = [{}];
    try {
      if (this.isFormulaSpecified()) {
        jsonLogicFormula = this.infixToJsonLogicParser.parse(this.costView.formula.replace(new RegExp(this.costView.infixSeparator, "g"), " "));
        formulaObj = new InfixFormula(this.costView.formula, this.costView, this.translateService);
      } else {
        formulaObj = false;
      }

    } catch (err) {
      jsonLogicFormula = [{}];
      formulaBroken = true;
      formulaObj = false;
    }

    if (this.costView.formulaIndex === "new") {
      this.newRow.infixFormula = this.costView.formula;
      this.newRow.jsonLogicFormula = jsonLogicFormula[0];
      this.newRow.prettyPrintInfixFormula = formulaBroken ? "NaN" : (formulaObj ? formulaObj.prettyPrint() : this.costView.emptyFormula);
      this.newRow.meta = this.costView.formulaMeta;
    } else {
      this.formulaCost.formulaCostItems[this.costView.formulaIndex].infixFormula = this.costView.formula;
      this.formulaCost.formulaCostItems[this.costView.formulaIndex].jsonLogicFormula = jsonLogicFormula[0];
      this.formulaCost.formulaCostItems[this.costView.formulaIndex].prettyPrintInfixFormula = formulaBroken ? "NaN" : (formulaObj ? formulaObj.prettyPrint() : this.costView.emptyFormula);
      this.formulaCost.formulaCostItems[this.costView.formulaIndex].meta = this.costView.formulaMeta;
      // this.saveFormulaCostItem(this.formulaCost.formulaCostItems[this.costView.formulaIndex]);
    }
    this.saveComponentFormula();
  }

  public initCostView() {
      if (!this.costView) { return; }
      this.setupInfixFormula();
  }

  public addNewRow(): void {
    if (!this.formulaCost) {
      this.formulaCost = new FormulaCost();
    }
    this.newRow = new FormulaCostItem();
    this.newRow.infixFormula = null;
    this.newRow.jsonLogicFormula = {};
    this.newRow.prettyPrintInfixFormula = this.costView.emptyFormula;
    this.newRow.meta = this.costView.formulaMeta;
    this.newRow.sortOrder = this.formulaCost.formulaCostItems.length + 1;
    this.newRow.formulaCostId = this.formulaCost.id;
    this.formulaCost.formulaCostItems.push(this.newRow);
    /*
    if (this.newRow.infixFormula) {
      const copy: FormulaCostItem = new FormulaCostItem();
      let jsonLogicFormula;
      try {
        jsonLogicFormula = this.infixToJsonLogicParser.parse(this.costView.formula.replace(new RegExp(this.costView.infixSeparator, "g"), " "));
      } catch (err) {
        jsonLogicFormula = [{}];
      }

      copy.formulaCostId = this.formulaCost.id;
      copy.infixFormula = this.newRow.infixFormula;
      copy.jsonLogicFormula = jsonLogicFormula.length > 0 ? jsonLogicFormula[0] : {};
      copy.sortOrder = this.formulaCost.formulaCostItems.length + 1;
      if (this.newRow.jsonDeterminants) {
        copy.jsonDeterminants = this.newRow.jsonDeterminants;
      }
      if (this.newRow.meta) {
        copy.meta = this.newRow.meta;
      }
      this.createFormulaCostItem(copy);
    }
    */
  }

  public deleteRow(formulaCostItemId: string, index: number): void {
    this.costControllerService.deleteFormulaCostItem(formulaCostItemId).subscribe(
      () => {
        this.responseSuccessful("FormulaCost item deleted!");
        this.formulaCost.formulaCostItems.splice(index, 1);
        this.fixCostItemIndexes();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  private createFormulaCostItem(formulaCostItem: any): void {
    console.log("Creating formulaCostItem", formulaCostItem);
    CostItemsComponent.sendSaveProcessingEvent();
    this.costControllerService.createFormulaCostItem(formulaCostItem).subscribe(
        (data) => {
          this.responseSuccessful("FormulaCost item created!");

          // @ts-ignore
          // this.newRow.id = data.id;
          // this.newRow.sortOrder = this.formulaCost.formulaCostItems.length + 1;
          // this.formulaCost.formulaCostItems.push(this.newRow);
          formulaCostItem.id = data.id;
          this.newRow = new FormulaCostItem();
          this.fixCostItemIndexes();
          this.closeDeterminantModal();
          CostItemsComponent.sendSaveProcessingEvent(false);
        },
        (error) => {
          this.showErrorMessage(error);
          this.closeDeterminantModal();
          CostItemsComponent.sendSaveProcessingEvent(false);
        },
    );
  }

  private static sendSaveProcessingEvent(state = true) {
    window.top.postMessage([{channel: "FormBuilder", message: JSON.stringify({event: "saveProcessing", state})}], "*");
  }

  private saveFormulaCostItem(formulaCostItem: any): void {
    console.log("Saving formulaCostItem", formulaCostItem);
    CostItemsComponent.sendSaveProcessingEvent();
    this.costControllerService.saveFormulaCostItem(formulaCostItem).subscribe(
        () => {
          CostItemsComponent.sendSaveProcessingEvent(false);
          this.responseSuccessful("FormulaCost item changed!");
          this.closeDeterminantModal();
        },
        (error) => {
          this.showErrorMessage(error);
          CostItemsComponent.sendSaveProcessingEvent(false);
          this.closeDeterminantModal();
        },
    );
  }

  private static isWithoutCondition(v: FormulaCostItem) {
    return !v.jsonDeterminants;
  }

  public isEmptyConditionInTablePresented(): boolean {
    const itemWithoutCondition = this.formulaCost.formulaCostItems.find(CostItemsComponent.isWithoutCondition);
    return !!itemWithoutCondition;
  }

  public isAddButtonDisabled(): boolean {
    const itemWithoutCondition = this.formulaCost.formulaCostItems.find(CostItemsComponent.isWithoutCondition);
    if ((!itemWithoutCondition || this.newRow.jsonDeterminants) && this.newRow.infixFormula) {
      return this.newRow.prettyPrintInfixFormula === "NaN";
    }
    return true;
  }

  public openNewDeterminantModal() {
    window.scrollTo(0, 0);
    this.store.state.common.determinantSection.topLayer = "list";
    this.determinantService.jsonString = this.newRow.jsonDeterminants;
    this.determinantService.selectedIndex = undefined;
    this.determinantService.initCostData();
  }

  public openDeterminantModal(index) {
    /*
    window.scrollTo(0, 0);
    this.store.state.common.determinantSection.topLayer = "list";
    this.determinantService.jsonString = this.formulaCost.formulaCostItems[index].jsonDeterminants;
    this.determinantService.selectedIndex = index;
    this.determinantService.initCostData();
    */
   this.selectedFormulaRow = this.formulaCost.formulaCostItems[index];
   this.showDeterminantBuilder = true;
  }

  public updateDeterminant(event: any) {
    console.log(event.jsonString);
    this.selectedFormulaRow.jsonDeterminants = event.jsonString;
  }

  public showModalHeader(e) {
    console.log(e);
    this.showDrawerHeader = e;
  }

  public saveDeterminantModal(jsonDeterminants: any) {
    if (this.selectedIndex !== undefined) {
      this.formulaCost.formulaCostItems[this.selectedIndex].jsonDeterminants = jsonDeterminants.jsonString || jsonDeterminants;
      this.saveFormulaCostItem(this.formulaCost.formulaCostItems[this.selectedIndex]);
    } else {
      this.newRow.jsonDeterminants = jsonDeterminants.jsonString || jsonDeterminants;
    }
    this.closeDeterminantModal();
  }

  public saveComponentFormula() {
    if (this.selectedFormulaRow.id) {
      this.saveFormulaCostItem(this.selectedFormulaRow);
    } else {
      this.createFormulaCostItem(this.selectedFormulaRow);
    }
  }

  public closeDeterminantModal() {
    this.selectedFormulaRow = new FormulaCostItem();
    this.selectedIndex = undefined;
    this.showDeterminantBuilder = false;
    this.jsonDeterminants = undefined;
  }

  public isDeterminantEmpty(jsonDeterminant: string): boolean {
    return !(jsonDeterminant && jsonDeterminant !== '[{"type":"OR","items":[]}]');

  }

  public addFormulaToCost($event): void {
    console.log("CostItemsComponent: addFormulaToCost", $event);
    this.initCostView();
    // this.formulaCost.formulaCostItems[$event.formulaIndex] = $event;
    // this.saveFormulaCostItem(this.formulaCost.formulaCostItems[$event.formulaIndex]);
    this.openFormula = false;
  }

  public addNewInfixFormula(): void {
    window.scrollTo(0, 0);
    if (!this.newRow.infixFormula) {
      this.newRow.infixFormula = "";
    }
    if (!this.newRow.meta) {
      this.newRow.meta = { name: "Drag and drop your formula below", isNew: true };
    }
    this.costView.isInfix = true;
    this.costView.formula = this.newRow.infixFormula;
    this.costView.formulaMeta = this.newRow.meta;
    this.costView.formulaType = "formula";
    this.costView.formulaIndex = "new";
    this.costView.value = false;
  }

  public openInfixFormula(index: any): void {
    // window.scrollTo(0, 0);
    this.selectedFormulaRow = this.formulaCost.formulaCostItems[index];
    console.log("openInfixFormula", this.selectedFormulaRow);
    const fci = this.formulaCost.formulaCostItems[index];
    if (!fci.id) {
      this.costView.formulaIndex === "new";
    }
    this.costView.isInfix = true;
    this.costView.formula = fci.infixFormula;
    this.costView.formulaMeta = fci.meta;
    this.costView.formulaType = "formula";
    this.costView.formulaIndex = index;
    this.costView.value = false;
    this.openFormula = true;
    // this.changeFormula.emit({ costView: this.costView, formulaIndex: index });
  }
}
